<div class="container">
  <h2>MiFID II: Research Unbundling</h2>
  <form  #userForm="ngForm" (ngSubmit)="submitFullFormDetails()" class="user-form">

    <div class="jpm-research-stepper">
      <div class="jpm-research-stepper__step {{ visibleTab == 1 ? 'jpm-research-stepper__step--active' : ''}}">ABOUT YOU</div>
      <div class="jpm-research-stepper__step {{ visibleTab == 2 ? 'jpm-research-stepper__step--active' : ''}}">LEGAL ENTITIES</div>
      <div class="jpm-research-stepper__step {{ visibleTab == 3 ? 'jpm-research-stepper__step--active' : ''}}">REVIEW &amp; SUBMIT</div>
    </div>

    <!-- first tab -->
    <div *ngIf="visibleTab == 1" class="about-tab mat-card">
      <div class="instructions">
        <p>This form should be completed by the person who is responsible for overseeing your access to research.  Only one contact name per organization is requested.</p>
        <p class="required-instruction">* = required</p>
      </div>
      <div class="form-row flex">

        <mat-form-field class="name">
          <input #firstNameInput autofocus matInput placeholder="Full Name *" name="fullName" [formControl]="fullNameFormControl" [(ngModel)]="this.leiModel.submitter.name">
          <mat-error *ngIf="fullNameFormControl.hasError('required')">
            Full Name is <strong>required</strong>
          </mat-error>
        </mat-form-field>

      <mat-form-field class="e-mail">
        <input matInput placeholder="Email *" name="email" [formControl]="emailFormControl" [(ngModel)]="this.leiModel.submitter.email">
        <mat-error *ngIf="emailFormControl.hasError('pattern')">
          Please enter a valid email address
        </mat-error>
        <mat-error *ngIf="emailFormControl.hasError('required')">
          Email is <strong>required</strong>
        </mat-error>
      </mat-form-field>


      <!--<mat-form-field class="phone">-->
        <!--<input matInput placeholder="Phone (optional)" name="phone" [(ngModel)]="this.leiModel.submitter.phone">-->
      <!--</mat-form-field>-->

        </div>

      <div class="nav-buttons">
        <button type="button" mat-raised-button class="btn-back" routerLink="/home" routerLinkActive="active">Back</button>
        <button type="button" mat-raised-button  [disabled]="isFirstTabInvalid()" color="primary" class="btn-continue" (click)="navigateToSecondTab()">Next</button>
      </div>
    </div>




    <!-- second tab -->
    <div *ngIf="visibleTab == 2" class="lei-tab">

      <div class="instructions">
        <p>Please create separate entries for each of your legal entities. MiFID II requires certain entities, including portfolio managers and independent investment advisors to bear the cost for third-party research or to pay for it from a separate research payment account funded by specific charges to underlying investors. The cost of electronic access to J.P. Morgan's research is USD 10,000 per client legal entity per annum (exclusive of any VAT or any other fees, taxes or other additional amounts).</p>
        <p>In addition, the UK Financial Conduct Authority’s (FCA) statement (PS 21/20), effective as of 1 March 2022, which outlines an optional exemption from the research unbundling rules in respect of FICC Research, allows UK-based institutional clients to access FICC Research free of charge.</p>
        <p>Contact your J.P. Morgan representative to discuss available Research packages.</p>
        <p>Any cost for access to J.P. Morgan’s research will be payable once your access has been confirmed.</p>
        <p class="required-instruction">* = required</p>
      </div>

      <mat-card class="lei-details-container">
        <div class="lei-details-wrapper">
          <app-lei-details [leiDetail]="leiDetail" *ngFor="let leiDetail of leiModel.legalEntityDetails"
                           (cardStateChange)="onCardStateChange($event)" (packagesModelChange)="onPackagesModelChange($event)" (contactsModelChange)="onContactsModelChange($event)"
                           (removeLeiFromModel)="removeLeiFromModel($event)" (navigationDisabled)="disableNavigation($event)"
                           (copyInvoiceFromLastLei)="copyInvoiceFromLastLEI($event)"
                           [submitterName] = "this.leiModel.submitter.name" [submitterEMail] = "this.leiModel.submitter.email"></app-lei-details>
        </div>
      </mat-card>

      <div class="nav-buttons">
        <button type="button" mat-raised-button class="btn-back" (click)="navigateToFirstTab()">Back</button>
        <button type="button" mat-raised-button color="primary" (click)="addLeiForm()">Add Another LEI</button>
        <button type="button" mat-raised-button color="primary" class="btn-continue" [disabled]="secondTabNavigationAllowed" (click)="navigateToThirdTab()">Next</button>
      </div>

    </div>


    <!-- third tab -->
    <div *ngIf="visibleTab == 3" class="submit-tab">

      <div *ngIf="!formSubmitted">

        <div class="token-wrapper">

          <p>We have sent a verification code to your email address: <strong>{{ leiModel.submitter.email }}</strong> </p>

          <p>Please type the code below to complete your submission:</p>

            <div class="flex" style="display:inline-flex;margin: 3em auto;align-items: center;justify-content: center;width:24em">
              <input class="verificationCodeInput" placeholder="Enter Code" name="onboardCode"  [formControl]="onboardCodeFormControl" [(ngModel)]="leiModel.onboardCode">
              <button type="button" mat-raised-button class="btn-token" (click)="getCode()">Resend</button>
            </div>
            <div>
              <!--<mat-error *ngIf="onboardCodeFormControl.hasError('required')">-->
                <!--Secure token is <strong>required</strong>-->
              <!--</mat-error>-->
              <mat-error *ngIf="codeErrorOnPage">
                {{ codeErrorMessage }}
              </mat-error>
              <mat-error *ngIf="serverError">
                There is a problem with the server. Please try again after some time.
              </mat-error>
            </div>
        </div>


        <div class="nav-buttons">
          <button type="button" mat-raised-button class="btn-back" (click)="navigateToSecondTab()">Back</button>
          <button type="submit" [disabled]="isCodeEntered()" mat-raised-button color="primary" class="btn-submit">Submit</button>
        </div>

      </div>

      <div class="thank-you" *ngIf="formSubmitted">
        <div class="form-submitted">
          <p style="font-size: 18px;"><strong>Thank you for submitting your information.</strong><p>
          <p>In the coming weeks, we will send you updated research terms for any in-scope entities interested in receiving research. These terms must be reviewed and agreed in order to complete provisioning access to J.P. Morgan’s research.</p>
          <p>If you have any questions in the interim, please do not hesitate to contact us at <a href="mailto:MiFID.II.Research.Access@jpmorgan.com">MiFID.II.Research.Access@jpmorgan.com</a></p>
        </div>
      </div>

    </div>

  </form>
  <!--<pre>{{submitter | json}}</pre> -->


</div>
